module.exports = __webpack_public_path__ + "1e850d69b7dbf66f65e19ab10bf0daaf.svg";